<script>
  import { createEventDispatcher } from 'svelte';
  import request from 'superagent';
  
  const dispatch = createEventDispatcher();
  const defaultSubitem = { id: null, title: "", about: "", tag: "", item_id: null, subitem_id: null, subitem_type: null, position: null }
  
  export let form_id = window.SUBITEM_FORM_ID;
  export let item_id = null;
  export let subitem = Object.assign({}, defaultSubitem);
  export let position = null;
  export let search_term = "";
  
  let suggestions = [];
  
  function commit() {
    let call = subitem.id ? request.put : request.post;
    call(`/form/${form_id}`)
    .send(Object.assign({item_id: item_id}, subitem))
    .then(resp => {
      subitem.id = resp.body.id;
    })
    .catch(resp => {
      console.log("problem detected in when commiting")
    });
  }
  
  function onSearchInput(ev) {
    let query = search_term;
    if (query.length < 3)
      return [];
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( "GET", "/p/news/items.hits?q="+query, false ); // false for synchronous request
    xmlHttp.send( null );
    var data = JSON.parse(xmlHttp.responseText)
    if (!('hits' in data))
      suggestions = [];
    suggestions = data['hits']['hits'].map(function(i) {
      return {
        subitem_id: window.btoa(i["_id"]+""),
        subitem_type: "item",
        title: i["_source"]["title"]
    }})
  }
  
  function remove() {
    dispatch('remove');
  }
  
  function onSubitemSuggested(index) {
    subitem = Object.assign(subitem, suggestions[index])
    subitem.position = position;
    dispatch("subitem", subitem )
    search_term = "";
    suggestions = [];
    subitem = Object.assign({}, defaultSubitem);
  }
</script>
<form action='/form/{form_id}'>
<div class='row item-link'>
<fieldset class='form-group col-12'>
{#if !subitem.subitem_id}
<input aria-label='Hledání souvislostí' bind:value='{search_term}' class='form-control w-100 underline-input' id='item-subitem-title' on:input='{onSearchInput}' placeholder='...' type='search'>
{#if suggestions.length}
<div class='m-0 position-relative shadow-lg border border-primary' style='left: 0px; top: 0em; z-index: 100'>
{#each suggestions as ss, i}
<div class='p-2 pntr bg-hover' on:click='{() => onSubitemSuggested(i)}'>
{ss.title}
</div>
{/each}
</div>
{/if}
{:else}
<div class='mt-2 d-flex justify-content-start'>
{#if subitem.id == null}
<a class='text-muted flex-fill' href='/n/{subitem.subitem_id}'>
{subitem.title}
</a>
{:else}
<a class='flex-fill' href='/n/{subitem.subitem_id}'>
{subitem.title}
</a>
{/if}
<button class='btn btn-danger-outline border-0 p-0 m-0' on:click|preventDefault='{remove}'>
&times;
</button>
</div>
{/if}
</fieldset>
</div>
</form>
